import styled, { createGlobalStyle } from 'styled-components';
import {
  COLOR_TYPOGRAPHY_LIGHT,
  COLOR_BACKGROUND_LIGHT,
  COLOR_TYPOGRAPHY_DARK,
  COLOR_BACKGROUND_LIGHTER,
} from '../constants';
export const AppStyle = createGlobalStyle`
/* source-sans-pro-300 - latin */
@font-face {
  font-family: 'Source Sans Pro';
  font-style: normal;
  font-weight: 300;
  src: local(''),
       url('/fonts/source-sans-pro-v21-latin-300.woff2') format('woff2'), /* Chrome 26+, Opera 23+, Firefox 39+ */
       url('/fonts/source-sans-pro-v21-latin-300.woff') format('woff'); /* Chrome 6+, Firefox 3.6+, IE 9+, Safari 5.1+ */
}
/* source-sans-pro-regular - latin */
@font-face {
  font-family: 'Source Sans Pro';
  font-style: normal;
  font-weight: 400;
  src: local(''),
       url('/fonts/source-sans-pro-v21-latin-regular.woff2') format('woff2'), /* Chrome 26+, Opera 23+, Firefox 39+ */
       url('/fonts/source-sans-pro-v21-latin-regular.woff') format('woff'); /* Chrome 6+, Firefox 3.6+, IE 9+, Safari 5.1+ */
}
/* source-sans-pro-600 - latin */
@font-face {
  font-family: 'Source Sans Pro';
  font-style: normal;
  font-weight: 600;
  src: local(''),
       url('/fonts/source-sans-pro-v21-latin-600.woff2') format('woff2'), /* Chrome 26+, Opera 23+, Firefox 39+ */
       url('/fonts/source-sans-pro-v21-latin-600.woff') format('woff'); /* Chrome 6+, Firefox 3.6+, IE 9+, Safari 5.1+ */
}

*{
    margin:0;
    padding:0;
}

html, body {
    background-color: #fff;
    color: #000;
    height:100%;
    box-sizing: border-box;
}

body {
    font-family: 'Source Sans Pro', sans-serif, -apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Oxygen,Ubuntu,Cantarell,Fira Sans,Droid Sans,Helvetica Neue,sans-serif;
    font-size: 16px;
    line-height: 1.2em;
    text-rendering: optimizeLegibility;
}
input,textarea,.react-datepicker{
    font-family:'Source Sans Pro', sans-serif, -apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Oxygen,Ubuntu,Cantarell,Fira Sans,Droid Sans,Helvetica Neue,sans-serif;
}

*,
*:before,
*:after {
    box-sizing: inherit;
}

table{
    margin: 20px 0;
    border-collapse:collapse;
    th{
        font-weight:bold;
        border:1px solid #F0F0F0;
        text-align:left;
        padding:5px;
    }
    td{
        text-align:left;
        border:1px solid #F0F0F0;
        padding:5px;
    }
}

.ReactVirtualized__Table{

    }
    .ReactVirtualized__Table__headerRow{
        color:${COLOR_TYPOGRAPHY_LIGHT};
        border-bottom:1px solid ${COLOR_BACKGROUND_LIGHT};
        font-size:14px;
    }

    .ReactVirtualized__Table__row{
        -webkit-transition: all 0.3s ease-out;
        transition: all 0.3s ease-out;
        align-items:center;
        background:${COLOR_BACKGROUND_LIGHTER};
        border-bottom:2px solid #FFF;
        &.active{

            .ReactVirtualized__Table__rowColumn{

            }

        }
    }
    .ReactVirtualized__Table__row:hover{

    }
    .ReactVirtualized__Table__rowColumn{
        align-items:center;
        color:${COLOR_TYPOGRAPHY_DARK};
        font-size:16px;
        &:first-child:after{
            content: '';
            position: absolute;
            bottom: 0;
            left: 0;
            width: 0;
            height: 0;
            border-style: solid;
            border-width: 0 5px 5px 0px;
            border-color: transparent transparent #FFF transparent;
        }
        a{
            color:${COLOR_TYPOGRAPHY_DARK};

            text-decoration:none;
            display:flex;
            align-items:center;
            font-weight:300;
            svg{
                margin-right:10px;
            }
        }
    }

`;

export const SIDEBAR_WIDTH = '23%';
export const NAVIGATION_WIDTH = '90px';
export const NAVIGATION_WIDTH_SMALL = '75px';
